<div class="modal-backdrop" *ngIf="show" (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body">
        <div class="text-center">
          <!-- Delete Icon -->
          <div class="delete-icon-container mb-4">
            <div class="delete-icon-background">
              <i class="fas fa-trash-alt"></i>
            </div>
          </div>

          <!-- Main Message -->
          <h5 class="modal-title mb-3">
            Are you sure you want to delete the {{ itemType }} "{{ itemName }}"?
          </h5>

          <!-- Warning Message -->
          <p class="warning-message text-muted">
            Please be aware that this action is irreversible<br />
            and the {{ itemType }} will be permanently removed<br />
            from the system.
          </p>
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="onCancel()">
          No, Cancel
        </button>
        <button type="button" class="btn btn-danger" (click)="onConfirm()">
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
</div>
